<template>
    <RegistrationStepPage step-name="regSummary">
        <div class="card">
            <div class="card-body">
                <Basics />
                <Participants class="mt-4" />
                <div class="row">
                    <InvoiceRecipientViewOnly class="mt-4 col-md-6" />
                    <Payment class="mt-4 col-md-6" />
                </div>
                <PriceOverview class="mt-4" />
                <Comment class="mt-4" />
                <GroupRegistration />
                <Terms />
            </div>
        </div>
    </RegistrationStepPage>
</template>

<script>
import Basics from "@/components/pages/registration/summary/Basics";
import Participants from "@/components/pages/registration/summary/Participants";
import Payment from "@/components/pages/registration/summary/Payment";
import PriceOverview from "@/components/pages/registration/summary/PriceOverview";
import Comment from "@/components/pages/registration/summary/Comment";
import Terms from "@/components/pages/registration/summary/Terms";
import GroupRegistration from "@/components/pages/registration/summary/GroupRegistration";
import RegistrationStepPage from '@/components/farbcode-core/Registration/RegistrationStepPage'

export default {
    name: "RegSummary",
    components: {
        GroupRegistration,
        Terms,
        Comment,
        PriceOverview,
        Payment,
        Participants,
        Basics,
        RegistrationStepPage
    }
}
</script>

<style scoped>

</style>
